import { Link } from "gatsby"
import React from "react"
import styles from './layout.module.css'
import Navbar from './navbar.js'
import logo from "../assets/hiroshimageisenn-logo-transparent.png"


export default function Layout({ children }) {
    return (
        <div className = {styles.parentContainer}>
            <Navbar />
            <div className = {styles.container}>{children}</div>
            <div className = {styles.bottomContainer}>
                    <div className={styles.bottom}><Link href="/" className={styles.link}>News</Link></div>
                    <div className={styles.bottom}><Link href="/exhibitions" className={styles.link}>Exhibitions</Link></div>
                    <div className={styles.bottom}><Link href="/about" className={styles.link}>About</Link></div>
                    <div className={styles.bottom}><a href="https://www.facebook.com/hiroshima.art/?ref=page_internal" className={styles.link} target = "_blank">Facebook</a></div>
                    <div className={styles.bottom}><a href="https://www.youtube.com/channel/UCX2J5F_wd70ZllCxS163OJg" className={styles.link} target = "_blank">Youtube</a></div>
                    <div className={styles.bottom}><Link href="/about#contact" className={styles.link}>Contact</Link></div>
            </div>
            <div className = {styles.bottomTextContainer}>
                <img src={logo} alt="Hiroshima Art Center Logo" className = {styles.bottomImage}/>
                <p className = {styles.bottomText}>&copy; HIROSHIMA ART CENTER</p>
            </div>
        </div>
    )
}